/**
 * Enum of promotions orientation types
 */
export const orientationTypes = {
    CASINO: 'casino',
    SPORT: 'sport',
    ESPORTS: 'esports',
    BINGO: 'bingo',
    JACKPOTS: 'jackpots',
    OTHER: 'other',
};

export const ALL = 'all';
